module.exports = __webpack_public_path__ + "static/img/yinpin.10eb339d.svg";